module.exports = require("@nrwl/workspace/src/command-line/shared");